export const SET_SKILLS_DATA = "SET_SKILLS_DATA";